import { FormControlLabel, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";

export default function BooleanPropertyEditor(props: PropertyEditorProps) {
    const { t } = useTranslation();
    return <>
        <FormControlLabel control={<Checkbox
            checked={props.value as boolean}
            onChange={(e) => props.onChanged(e.target.checked)} />}
            label={t(props.property.displayName)} />
    </>
}
